import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  casinoWrap: {
    padding: "40px 100px",
    [theme.breakpoints.down("lg")]: {
      padding: "30px 15px",
    },
  },
  casinoCard: {
    borderRadius: "10px",
    overflow: "hidden",
    height: "700px",
    "& img": {
      width: "100%",
      height: "100%",
      ObjectFit: "cover",
    },
    [theme.breakpoints.down("sm")]: {
      height: "280px",
    },
  },

  casinoBanner: {
    height: "380px",
    borderRadius: "10px",
    overflow: "hidden",
    marginBottom: "20px",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    [theme.breakpoints.down("sm")]: {
      height: "200px",
    },
  },
  casinoCardRightCard: {
    borderRadius: "10px",
    overflow: "hidden",
    height: "340px",
    marginBottom: "20px",
    "& img": {
      width: "100%",
      height: "100%",
      // ObjectFit: "cover",
    },
    [theme.breakpoints.down("sm")]: {
      height: "200px",
    },
  },
}));
